import React from "react";
// Wrapper for dots.svg image created for fill and stoke color dynamically set
const DotsMenuIcon = props => {
    const {width, height, fill} = props
    return (
        <svg width={width} height={height} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>puntini</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Assets_icone" transform="translate(-764.000000, -12593.000000)" fill={fill}>
                    <g id="puntini" transform="translate(764.000000, 12593.000000)">
                        <g id="Group-4" transform="translate(0.000000, 40.000000)">
                            <circle id="Oval-Copy-5" transform="translate(90.000000, 10.000000) rotate(90.000000) translate(-90.000000, -10.000000) " cx="90" cy="10" r="10"></circle>
                            <circle id="Oval-Copy-6" transform="translate(50.000000, 10.000000) rotate(90.000000) translate(-50.000000, -10.000000) " cx="50" cy="10" r="10"></circle>
                            <circle id="Oval-Copy-7" transform="translate(10.000000, 10.000000) rotate(90.000000) translate(-10.000000, -10.000000) " cx="10" cy="10" r="10"></circle>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default DotsMenuIcon